module.exports = __webpack_public_path__ + "static/media/caffe-milano-2.87c70874.jpg";